import { render, staticRenderFns } from "./ExpedicaoCargaFormDetalhes.vue?vue&type=template&id=973fbd3c"
import script from "./ExpedicaoCargaFormDetalhes.vue?vue&type=script&lang=js"
export * from "./ExpedicaoCargaFormDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports